<template>
  <main class="page content">
    <section class="container">
      <episode-filter></episode-filter>
      <div :class="!loading ? '' : 'loading'">
        <episode v-if="episodes && episodes.length" v-for="(episode, index) in episodes" :index="index" :episode="episode" :key="episode.slug"></episode>
        <div v-if="!episodes || !episodes.length">
          <h2>No Results</h2>
          <p>Please try again</p>
        </div>
        <v-waypoint @waypoint-in="nextPage" v-if="!loading"></v-waypoint>
      </div>
    </section>
    <button class="sttButton button is-primary" @click="scrollToTop" v-if="scrolled">Top</button>
  </main>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EpisodeFilter from '@/components/episodes/EpisodeFilter'
import Episode from '@/components/episodes/Episode'

export default {
  name: 'episodes',
  data () {
    return {
      page: 1,
      loading: true,
      topics: null,
      scrolled: false
    }
  },
  mounted () {
    if (!this.topic) {
      this.fetchEpisodes()
    }
  },
  methods: {
    nextPage () {
      if (this.page < this.totalEpisodePages) {
        this.page++
      }
    },
    handleScroll (direction, going) {
      if (direction.y === 'down' && going === 'in') {
        this.scrolled = true
      } else if (direction.y === 'up' && going === 'out') {
        this.scrolled = false
      }
    },
    scrollToTop () {
      window.scrollTo(0, 0)
      this.scrolled = false
    },
    fetchEpisodes (scrollToTop = false, replace = true) {
      let vm = this
      let topicId = vm.thisTopic ? vm.thisTopic.id : ''
      vm.$axios.get('/episodes', {
        params: {
          page: vm.page,
          year: vm.year,
          topic: topicId
        }
      })
      .then((response) => {
        vm.loading = false
        if (!replace) {
          vm.addToEpisodes(response.data.posts)
        } else {
          vm.setEpisodes(response.data)
        }
        if (scrollToTop) {
          vm.scrollToTop()
        }
      })
      .catch((err) => {
        vm.loading = false
        console.log(err.response)
      })
    },
    setPage (i, push = false) {
      let vm = this
      vm.page = parseInt(i)
    },
    ...mapActions([
      'setEpisodes',
      'addToEpisodes'
    ])
  },
  components: {
    EpisodeFilter,
    Episode
  },
  computed: {
    topic () {
      return this.$route.params.topic
    },
    year () {
      return this.$route.query.year
    },
    thisTopic () {
      let vm = this
      if (vm.topics && vm.topic) {
        return vm.topics.find((topic) => {
          return topic.slug === vm.topic
        })
      }
    },
    ...mapGetters([
      'episodes',
      'totalEpisodePages'
    ])
  },
  watch: {
    year () {
      this.setPage(1)
      this.fetchEpisodes(true, true)
    },
    page () {
      this.fetchEpisodes(false, false)
    },
    thisTopic () {
      this.setPage(1)
      this.fetchEpisodes(true, true)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import ../assets/styles/mixins

.page
  padding-bottom: 120px
  .container
    +desktop
      padding: 0
</style>



// WEBPACK FOOTER //
// Episodes.vue?5a4488ca